module.exports = __webpack_public_path__ + "static/media/showen.f40dd25a.png";